import api from '@shared/services/api';
import { UserOption } from '../types/invitation';

class UserDeletionService {
  /**
   * Get all users with accepted invitations in the organization
   * @returns Promise with array of users with accepted invitations
   */
  async getUsersWithAcceptedInvitations(): Promise<UserOption[]> {
    const response = await api.get('/user-deletion/users-with-accepted-invitations');
    return response.data.data;
  }

  /**
   * Delete a user and transfer their content to another user
   * @param invitationId ID of the invitation of the user to delete
   * @param transferToUserId ID of the user to transfer content to
   * @returns Promise with deletion result
   */
  async deleteUserAndTransferContent(
    invitationId: string,
    transferToUserId: string
  ): Promise<any> {
    const response = await api.post('/user-deletion/delete-and-transfer', {
      invitationId,
      transferToUserId
    });
    return response.data.data;
  }
}

export const userDeletionService = new UserDeletionService();
